import { useEffect, useState } from "react";
import "../styles/componentStyles/PermissionsDeniedComponent.scss";
export function PermissionsDeniedComponent(props: any) {
  const [animateIn, setAnimateIn] = useState(false);
  const [refreshButtonClicked, setRefreshButtonClicked] = useState(false);
  useEffect(() => {
    if (props.permissionsDenied) {
      setAnimateIn(true);
    }
  }, [props.permissionsDenied]);

  return (
    <>
      <div
        className={`deniedPermissionsScreen ${
          animateIn ? "animateIn" : "hidden"
        }`}
      >
        <div className={`modalWrapper`}>
          <div className="modal">
            <img
              className="bkg"
              src="https://rprintelinnovation.blob.core.windows.net/$web/assets/2Dassets/popUpBackground.png"
              alt=""
            />
            <div className="text">
              You need to accept
              <br />
              motion permission
              <br />
              to continue
            </div>
            <div
              className={`refreshButton ${
                refreshButtonClicked ? "active" : ""
              }`}
              onClick={() => {
                setRefreshButtonClicked(true);
                setTimeout(() => {
                  window.location.reload();
                }, 750);
              }}
            >
              <img
                className="bkg"
                src="https://rprintelinnovation.blob.core.windows.net/$web/assets/2Dassets/instructionsButtonBkg.png"
                alt=""
              />
              <div className="innerText">Refresh</div>
              <img
                className="activeBkg"
                src="https://rprintelinnovation.blob.core.windows.net/$web/assets/2Dassets/instructionsButtonActiveBkg.svg"
                alt=""
              />
              <div className="innerTextActive">Refresh</div>
              <img
                className="leftArrow"
                src="https://rprintelinnovation.blob.core.windows.net/$web/assets/2Dassets/instructionsButtonLeftArrow.png"
                alt=""
              />
              <img
                className="rightArrow"
                src="https://rprintelinnovation.blob.core.windows.net/$web/assets/2Dassets/instructionsButtonRightArrow.png"
                alt=""
              />
            </div>
          </div>
          <div className="scannerTopLine"></div>
          <div className="scannerBottomLine"></div>
        </div>
      </div>
    </>
  );
}
